import store from '@/store'
import { sharedState } from '@/services/sharedState'

function syncSharedState()
{
    sharedState.isCenturion = !!store.get('requestKeys/isCenturion')
}

export function setIsCenturion(value)
{
    const bool = !!value
    store.set('requestKeys/isCenturion', bool)
    sharedState.isCenturion = bool
}

export function clearSession()
{
    store.set('requestKeys/isCenturion', false)
    sharedState.isCenturion = false
}

export function initCenturionStateFromStore()
{
    syncSharedState()
}

export function isCenturionLayout(route)
{
    return route?.meta?.layout === 'centurion'
}

export function redirectToLoginAfterLogout(router, route, lang)
{
    if (isCenturionLayout(route))
    {
        router.push('/' + lang + '/login-centurion')
    }
    else
    {
        router.push({ name: 'auth-login', params: { lang } })
    }
}

export default {
    setIsCenturion,
    clearSession,
    initCenturionStateFromStore,
    isCenturionLayout,
    redirectToLoginAfterLogout,
}
